import { defineComponent } from 'vue'
import { RouterLink } from 'vue-router'
import { Row as VanRow, Col as VanCol, Image as VanImage, showImagePreview } from 'vant'
import type { ForumPost } from '@/stores/forum-store'
import UserAvatar from '@/components/user-avatar'
import iconTop from '@/assets/forum/top.png'
import iconEssence from '@/assets/forum/essence.png'
import iconVip from '@/assets/forum/vip.png'
import iconThumbUp from '@/assets/forum/thumb-up.svg'
import iconEye from '@/assets/forum/eye.svg'
import iconComment from '@/assets/forum/comment.svg'
import iconHk from '@/assets/forum/hk.png'
import iconMacau from '@/assets/forum/macau.png'

// 六合论坛帖子卡片（全局 .forum-list 样式）的公共片段：论坛首页、论坛搜索、作者历史帖子共用

/** 作者头像 + 昵称（VIP 标红带图标）+ 发帖时间 */
export const ForumUserImg = defineComponent({
  name: 'UserImg',
  props: {
    post: { type: Object as () => ForumPost, required: true },
  },
  setup(props) {
    return () => (
      <div class="user-img">
        <div class="left-image">
          <UserAvatar src={props.post.headPic} alt={props.post.username} size="0.72rem" />
        </div>
        <div class="user-info">
          <div class={['name', props.post.vip ? 'red' : '']}>
            {props.post.username}
            {props.post.vip === 1 && <img src={iconVip} alt="VIP" />}
          </div>
          <div class="time">{props.post.createTime}</div>
        </div>
      </div>
    )
  },
})

/** 大图预览 */
function previewImages(images: string[], i: number) {
  if (!images.length) return
  showImagePreview({ images, startPosition: i, closeable: true })
}

/**
 * 帖子配图（最多 3 张），点开大图预览；超过 3 张时在第 3 张上标总数。
 * 同一张图可能出现两次，key 用「地址 + 位置」。
 */
export function renderPostPictures(pictureList: string[]) {
  return pictureList.slice(0, 3).map((src, i) => (
    <VanCol
      key={`${src}-${i}`}
      span={8}
      onClick={(e: Event) => {
        e.stopPropagation()
        previewImages(pictureList, i)
      }}
    >
      <div class="image-body">
        <VanImage src={src} fit="cover" width="100%" height="100%" />
        {i === 2 && pictureList.length > 3 && <div class="length">共{pictureList.length}张</div>}
      </div>
    </VanCol>
  ))
}

/** 标题行里的置顶 / 精华图标 + 标题（已读变灰） */
export function renderPostTitle(post: ForumPost) {
  return (
    <>
      {post.top === 1 && (
        <span class="up">
          <img src={iconTop} width="25" alt="置顶" />
        </span>
      )}
      {post.highQuality === 1 && (
        <span>
          <img class="icon" src={iconEssence} alt="精华" />
        </span>
      )}
      <div class="formtitle" style={{ color: post.read ? '#999' : '' }}>
        {post.title}
      </div>
    </>
  )
}

/** 摘要（innerHTML，链接包在外面）+ 配图 */
export function renderPostSummary(post: ForumPost) {
  return (
    <>
      <RouterLink class="btn-reset block" to={`/forum/detail/${post.postId}`}>
        <div class="text van-multi-ellipsis--l3" innerHTML={post.description} />
      </RouterLink>

      {post.pictureList && post.pictureList.length > 0 && (
        <div class="img-box">
          <div class="images">
            <VanRow class="img-box-3">{renderPostPictures(post.pictureList)}</VanRow>
          </div>
        </div>
      )}
    </>
  )
}

/** 底部点赞 / 阅读 / 评论数 + 彩种 */
export function renderPostStats(post: ForumPost) {
  const isHk = post.lotteryType === 'hk'
  return (
    <VanRow class="tool-ft tom-col">
      <VanCol span={6}>
        <div class="tool-inner">
          <img src={iconThumbUp} width="16" height="16" alt="点赞" />
          <span class="num">{post.likeCount}</span>
        </div>
      </VanCol>
      <VanCol span={6}>
        <div class="tool-inner">
          <img src={iconEye} width="16" height="16" alt="阅读" />
          <span class="num">{post.clickCount}</span>
        </div>
      </VanCol>
      <VanCol span={6}>
        <div class="tool-inner">
          <img src={iconComment} width="16" height="16" alt="评论" />
          <span class="num">{post.commentCount}</span>
        </div>
      </VanCol>
      <VanCol span={6} class="ntool">
        <div>
          <img src={isHk ? iconHk : iconMacau} alt="" />
          <span class="num">{isHk ? '香港' : '澳门'}</span>
        </div>
      </VanCol>
    </VanRow>
  )
}
